'use es6';

export const RtlLangs = ['ar', 'fa', 'ha', 'he', 'ks', 'ckb', 'ps', 'ur', 'yi'];